import { useTranslation } from 'react-i18next';
import { TravelCariAccountEditor } from '@/components/travel/cari/account-editor';

/** Booking's quick-create uses the canonical cari editor and validation. */
export function CustomerDrawer({
  open,
  onOpenChange,
  onCustomerCreated,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onCustomerCreated?: (customer: {
    id: string;
    firstName: string;
    lastName: string;
    email?: string;
  }) => void;
}) {
  const { t } = useTranslation('travelCari');
  return (
    <TravelCariAccountEditor
      open={open}
      onOpenChange={onOpenChange}
      type={{ code: 'M', source: 'customer', label: t('account.customerType') }}
      onSaved={(account) =>
        onCustomerCreated?.({
          id: account.id,
          firstName: account.firstName ?? '',
          lastName: account.lastName ?? '',
          email: account.email,
        })
      }
    />
  );
}
